export default __webpack_public_path__ + "static/media/falling_stones.d69ed704.mp3";